import { toast } from "@heroui/react";

/**
 * House-standard write-failure toast: a calm title plus a specific recovery
 * line. Pass the description as a short "what didn't happen + try again" line
 * (e.g. "Your entry wasn't saved. Try again.").
 */
export function notifyError(description: string) {
    toast.danger("Something went wrong", { description, timeout: 3000 });
}
